import { createEmpireClient } from "@empireapi/client";

export const empire = createEmpireClient({
  baseUrl: "/api/v1",
  clientId: "",
});
